<template>
  <el-popover
    popper-class="popover-select"
    placement="top-start"
    trigger="click"
    v-model="visible"
    :visible-arrow="false"
  >
    <el-radio-group :value="value" size="mini" v-if="!multiple" @input="change">
      <el-radio v-for="opt in options" :key="opt.value" :label="opt.value">{{
        opt.text
      }}</el-radio>
    </el-radio-group>
    <div slot="reference">
      <i v-if="icon && isElIcon" :class="icon"></i>
      <span
        v-if="icon && !isElIcon"
        class="icon"
        :class="{ [icon]: !!icon }"
      ></span>
    </div>
  </el-popover>
</template>

<script>
import find from 'lodash/find';

export default {
  props: {
    text: String,
    icon: String,
    hoverIcon: String,
    multiple: {
      type: Boolean,
      default: () => false
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Array, String],
      default: () => []
    }
  },
  computed: {
    isElIcon() {
      if (this.icon?.indexOf('el-icon') === 0) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    change(val) {
      //console.log('va', val);
      if (!this.multiple) {
        const select = find(this.options, opt => opt.value === val);
        this.$emit('input', select.value);
        this.visible = false;
        return;
      }
      const values = val.reduce((acc, v) => {
        const select = find(this.options, opt => opt.value === v);
        if (select) {
          acc.push(select.value);
        }
        return acc;
      }, []);
      this.$emit('input', values);
    },
    search(value) {
      this.$emit('search', value);
    }
  }
};
</script>

<style lang="less" scoped>
.popover-select {
  color: #fff;
  border: 0;
  z-index: 2000 !important;
  min-width: 110px;
  .el-checkbox-group {
    display: flex;
    flex-direction: column;

    .el-checkbox {
      margin: 2px 0;
      &:hover {
        color: @blue;
      }
    }
  }

  .el-radio {
    display: block;
    line-height: 20px;
    margin: 2px 0;
  }
}

.el-radio__label {
  color: #133c62;
}

.el-popover {
  background: rgba(255, 255, 255, 0.8);
}

.el-popover__reference {
  padding: 8px;
  .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    &.layer {
      background-image: url(../../asset/map-layer-grey.png);
    }
  }
  &:hover {
    background: linear-gradient(180deg, #3cd4e2, #738de1);
    .layer {
      background-image: url(../../asset/map-layer.png);
    }
  }
}
</style>